module.exports = __webpack_public_path__ + "static/bronze_dragon-479412345ba5d74e9b8bf479edff8fda.jpg";